import { Dialog, DialogTitle, Fab, Grid, List, ListItemButton, ListItemIcon, ListItemText, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { allRoles } from 'config';
import CheckIcon from '@mui/icons-material/Check';
import config, { prodProjeEskgId, projeEskgId, testProjeEskgId } from '../../../config';
import RoleUnitDataTable from '../DataTable/RoleUnitDataTable';
import { useSelector } from 'react-redux';
import { isRoleCheckList } from 'app/utils/appHelpers';
import { useTemplateFontSettings } from 'styles/templateFontSettings';

function RoleListDialog({ handleCloseRole, onClose, open, inst = [], type = "role", usersRoleList, pageTitle }) {

  const [loading, setLoading] = useState(true);
  let [allRolesData, setAllRolesData] = useState([]);
  const [allInstData, setAllInstData] = useState([]);

  const [openInstDialog, setOpenInstDialog] = useState(false);
  const [openRoleDialog, setOpenRoleDialog] = useState();
  const [openUnitDialog, setOpenUnitDialog] = useState(false);
  const [selectedRole, setSelectedRole] = useState(false);
  const [selectedInst, setSelectedInst] = useState(null);
  const [selectedUnit, setSelectedUnit] = useState(null);
  const [unitData, setUnitData] = useState([]);
  const [selectUnitIdStatus, setSelectUnitIdStatus] = useState();
  const unitList = useSelector(state => state.unit.data || []);
  const authUser = useSelector(state => state.auth.authUser);
  const userRoles = authUser.userRoles;

  const handleListItemClick = async (item, selectedDialogType) => {

    if (selectedDialogType === 1) { // rol dialogu

      setSelectedRole(item.roleId);
      if (item.instSelect === 1) {
        if (item.roleId === 369 || item.roleId === 372) { // birim seçmesi gereken rol
          setSelectUnitIdStatus(true);

          if (item.roleId === 372) {

            setAllInstData(config.institutions.filter(x => x.inst === 'YK'));
            setSelectedInst('YK')
          }
        }
        setOpenRoleDialog(false);
        setOpenInstDialog(true);

      } else { // yk giriyor sadece instSelect yok çünkü, dstatus olabilir simdilik sadece yk eklendigi icin burayı degistirmedm
        let intValue = "";
        if (item.roleId !== 417) { // kurul acilacaksa
          intValue = 'YK'
        }
        setSelectedInst('YK')
        await handleCloseRole(item.roleId, intValue);

        setOpenRoleDialog(false);

      }

    } else if (selectedDialogType === 2) { // inst dialogu
      setSelectedInst(item.inst)
      setOpenInstDialog(false);

      if (selectUnitIdStatus === true) {

        setOpenInstDialog(false);
        setOpenUnitDialog(true);
        let res = [];

        if (item.inst === 'YK') {
          res = unitList.filter(x => x.inst === 'YK')
        } else {
          res = unitList.filter(x => x.inst === item.inst)
        }
        res = res.filter(item => !usersRoleList.map(x => x.customId).includes(item.id));// userın unitlerdeki rollerinden daha önce varsa o çıkarılıyor listeden
        setUnitData(res);
        setSelectedUnit(null)

      } else {
        await handleCloseRole(selectedRole, selectedInst);
      }
    } else { // unit seçme
      setSelectedUnit(item.id);
      await handleCloseUnit();
    }
  };

  const handleClose = async () => {
    setOpenInstDialog(false);
    setOpenRoleDialog(false);

    // handleCloseRole();
    onClose();
  };

  const handleCloseUnit = async () => {
    setOpenUnitDialog(false);
    await handleCloseRole(selectedRole, selectedInst, selectedUnit);
    setSelectUnitIdStatus(false)
  };

  useEffect(() => {
    // if (type !== "dstatus") {
    if (selectedInst !== null && selectedInst !== false) {
      if (selectUnitIdStatus === undefined) {
        handleCloseRole(selectedRole, selectedInst);
      }
    }
    if (selectedUnit !== null) {
      handleCloseUnit();
    }
    // }

  }, [selectedInst, selectedUnit]);

  useEffect(() => {
    let rolesData = []; // Initialize an empty array for roles data

    // if (open === true && type === "userParticipant") {
    //   setOpenInstDialog(true);
    //   setSelectedRole(100); // kurulsis üye
    //   rolesData = allRoles; // Add all roles data
    //   setAllInstData(config.institutions.filter(x => x.inst !== 'YK'));

    // } else if (open === true && type === "dstatus") {
    //   rolesData = allRoles.filter(x => x.roleId === 416 || x.roleId === 417);
    //   setOpenRoleDialog(true);
    //   // setSelectedRole(416); 

    // } else {
    setOpenRoleDialog(open);

    if (isRoleCheckList(userRoles, [1])) {
      rolesData = allRoles.filter(x => x.roleId !== 416 && x.roleId !== 417);
      setAllInstData(config.institutions);

    } else {
      if (isRoleCheckList(userRoles, [373])) {
        rolesData = allRoles.filter(x => x.roleId === 373 || x.roleId === 369 || x.roleId === 368 || x.roleId === 418);
        setAllInstData(config.institutions.filter(x => x.inst !== 'YK'));

      }
      if (isRoleCheckList(userRoles, [370])) {
        if (rolesData.length === 0) {
          rolesData = allRoles.filter(x => x.roleId === 370 || x.roleId === 371 || x.roleId === 372 || x.roleId === 418);
        } else {
          rolesData = [
            ...rolesData,
            ...allRoles.filter(x => x.roleId === 370 || x.roleId === 371 || x.roleId === 372 || x.roleId === 418)
          ];
        }
        setAllInstData(config.institutions.filter(x => x.inst === 'YK'));

      }
    }
    // }
    setAllRolesData(rolesData); // Set the roles data
    setLoading(false);
  }, [open, type])

  const columnData = [
    // { id: 'id', align: 'left', disablePadding: false, label: "Kurul/Kol/Komisyon ID" },
    { id: 'inst', align: 'left', disablePadding: false, label: "Kurum" },
    { id: 'name', align: 'left', disablePadding: true, label: "Kurul/Kol/Komisyon Adı" },
    { id: 'islemler', align: 'left', disablePadding: true, label: "İşlemler" }
  ];
  
  return (

    <React.Fragment>

      <Dialog onClose={handleClose} open={openRoleDialog} maxWidth="xs" fullWidth scroll="paper">
        <DialogTitle sx={{  }}>{pageTitle} / Rol Seçiniz</DialogTitle>
        <Grid container spacing={2}>

          <Grid item xs={12} sm={12} lg={12} >

            <List disablePadding>
              {allRolesData.map((item) => (

                <ListItemButton
                  component={"li"}
                  alignItems={"flex-start"}
                  sx={{
                    borderBottom: 1,
                    borderBottomColor: 'divider',
                    px: 3,

                    '&:hover .ListItemIcons': {
                      opacity: 1
                    }
                  }}
                >

                  <ListItemText
                    primary={<Typography component={"div"}>
                      <Typography variant={"body1"} mb={1} sx={{  }}>

                        {item.name}
                      </Typography>
                    </Typography>} />

                  <ListItemIcon
                    className={"ListItemIcons"}
                    sx={{
                      position: 'absolute',
                      right: 10,
                      bottom: 6,
                      transition: 'all 0.2s',
                      // opacity: 0,
                    }}
                  >
                    <Fab color={"primary"}

                      sx={{
                        bgcolor: 'grey.300',
                        '&:hover': {
                          bgcolor: (theme) => theme.palette.primary.main
                        },
                        width: 35,  // özel genişlik
                        height: 35, // özel yükseklik
                        minHeight: 35, // minimum yükseklik
                        '& .MuiSvgIcon-root': { // icon boyutu
                          fontSize: '1rem'
                        }
                      }}
                      onClick={() => handleListItemClick(item, 1)} key={item.roleId} ><CheckIcon /></Fab>

                  </ListItemIcon>
                </ListItemButton>

              ))}

            </List>
          </Grid>

        </Grid>
      </Dialog>

      <Dialog onClose={handleClose} open={openInstDialog} maxWidth="xs" fullWidth scroll="paper">
        <DialogTitle sx={{  }}>{pageTitle} / Kurum Seçiniz</DialogTitle>
        <Grid container spacing={2}>

          <Grid item xs={12} sm={12} lg={12}>

            <List disablePadding>

              {allInstData.map((item) => (

                inst.length === 0 || inst.includes(item.inst) ? (

                  <>

                    <ListItemButton
                      component={"li"}
                      alignItems={"flex-start"}
                      sx={{
                        borderBottom: 1,
                        borderBottomColor: 'divider',
                        px: 3,

                        '&:hover .ListItemIcons': {
                          opacity: 1
                        }
                      }}
                    >

                      <ListItemText
                        primary={<Typography component={"div"}>
                          <Typography variant={"body1"} mb={1} sx={{  }}>

                            {item.inst}
                          </Typography>
                        </Typography>} />

                      <ListItemIcon
                        className={"ListItemIcons"}
                        sx={{
                          position: 'absolute',
                          right: 10,
                          bottom: 6,
                          transition: 'all 0.2s',
                          // opacity: 0,
                        }}
                      >
                        <Fab size="small"
                          sx={{
                            bgcolor: 'grey.300',
                            '&:hover': {
                              bgcolor: (theme) => theme.palette.primary.main
                            },
                            width: 35,  // özel genişlik
                            height: 35, // özel yükseklik
                            minHeight: 35, // minimum yükseklik
                            '& .MuiSvgIcon-root': { // icon boyutu
                              fontSize: '1rem'
                            }
                          }}

                          color={"primary"} onClick={() => handleListItemClick(item, 2)} key={item.inst} ><CheckIcon /></Fab>

                      </ListItemIcon>

                    </ListItemButton>

                  </>
                ) : null

              ))}

            </List>

          </Grid>
        </Grid>
      </Dialog>

      <Dialog onClose={handleCloseUnit} open={openUnitDialog} maxWidth="sm" fullWidth scroll="paper">

        <RoleUnitDataTable type={"unit"} mainData={unitData} column={columnData} pageTitle={pageTitle + "/" + selectedInst} handleCloseUnit={handleCloseUnit} setOpenUnitDialogStatus={openUnitDialog} handleListItemClick={handleListItemClick} />

      </Dialog>

    </React.Fragment >
  );
}

export default RoleListDialog